import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import { PermissionService } from 'src/app/core/services/auth/permission.service';
import { Title } from '@angular/platform-browser';
// import { FeatureToggleService } from 'src/app/core/services/featuretoggle.service';
import { EnvironmentEnum } from 'src/app/shared/models/generic.models';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-marketplace-details',
  templateUrl: './marketplace-details.component.html',
})
export class MarketplaceDetailsComponent implements OnInit {
  environment = environment;
  id?: string | null;
  showLocalSimon: boolean = false;
  iframeUrl: string = environment.simonUrl;
  env?: EnvironmentEnum | null;

  constructor(
    private route: ActivatedRoute,
    private titleService: Title,
  ) {
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id');
      this.ngOnInit();
    });
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.id + ' | Agent Portal');
    this.openSimonSso(this.id);
  }

  openSimonSso(id?: string | null) {
    if (this.showLocalSimon) {
      this.iframeUrl = environment.simonLocalUrl;
    } else {
      this.iframeUrl = environment.simonUrl;
    }
    if (id === 'Annuities') {
      this.iframeUrl += '/annuities/marketplace';
    } else {
      this.iframeUrl += '/marketplace/current-offerings';
    }
  }
}